import { createStyles } from '@mantine/core';

export const useStyles = createStyles(
  (theme, { progressWidth }: { progressWidth: string | null }) => ({
    container: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      gap: theme.other.spacing._8,
      background: theme.white,
      borderRadius: theme.radius.lg,
      padding: theme.other.spacing._8,
      paddingRight: theme.other.spacing._16,
      cursor: 'pointer',
      border: `1px solid transparent`,
      transition: 'border 0.2s ease-in-out',
      height: 72,
      boxSizing: 'border-box',

      '&.compact': {
        minWidth: 300,
        maxWidth: 350,
      },

      '&:hover': {
        border: `1px solid ${theme.colors.gray2[3]}`,
      },
    },
    hasBorder: {
      border: `1px solid ${theme.colors.gray2[1]}`,
    },
    expiring: {
      border: `1px solid #1BC4CF`,
    },

    expirationChip: {
      position: 'absolute',
      top: -8,
      left: '50%',
      transform: 'translateX(-50%)',
      height: 16,
      borderRadius: theme.radius.lg,
      background:
        'linear-gradient(0deg, rgba(27, 196, 207, 0.10) 0%, rgba(27, 196, 207, 0.10) 100%), #FFF',
      color: '#0EA2AC',
      padding: `0 ${theme.other.spacing._8}px`,
    },

    badge: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 52.5,
      height: 58.5,
      marginBottom: -theme.other.spacing._2,
      flexShrink: 0,
    },
    badgeBgr: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 1,
    },
    rewardValue: {
      position: 'relative',
      color: theme.white,
      zIndex: 2,
    },
    badgeIcon: {
      position: 'relative',
      zIndex: 2,
    },

    content: {
      display: 'flex',
      flexFlow: 'column nowrap',
      flexGrow: 1,
      overflow: 'hidden',
    },
    title: {
      fontWeight: 800,
      color: theme.colors.gray2[6],
    },
    description: {
      color: theme.colors.gray2[4],
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    completedAt: {
      paddingTop: theme.other.spacing._4,
      color: theme.colors.gray2[3],
    },

    progressContainer: {
      position: 'relative',
      width: '100%',
      paddingTop: theme.other.spacing._8,
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      gap: theme.other.spacing._8,
    },
    progressTrack: {
      position: 'relative',
      flexGrow: 1,
      height: 4,
      background: theme.colors.gray[1],
      borderRadius: theme.radius.lg,
      zIndex: 1,
    },
    progressBarFill: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: progressWidth ?? undefined,
      height: 4,
      minWidth: 12,
      background: 'linear-gradient(90deg, #10625D 0%, #59D0C9 202.25%), #F1F3F5',
      borderRadius: theme.radius.lg,
      zIndex: 2,
    },
    progressCaption: {
      flexShrink: 0,
    },
  })
);
